export default "__VITE_ASSET__BNxjJNeW__"